import React from 'react';

const Allcourse = () => {
    return (
        <div>
            <h1>all course</h1>
        </div>
    );
};

export default Allcourse;